import { getFormatedDate } from "../../utils/common";
export const printKOT = ({
  type,
  cartItems,
  roomData,
  extraCartItems,
  cancelItems = [],
  comment,
  billNo,
  customer,
  printers = [],
  blutoothOperations,
  hightLightOrderIDLastNDigits = 0,
}) => {
  const date = new Date();
  const formattedDateTime = getFormatedDate(date);
  const kotPrinters = printers.filter(
    (printer) =>
      (printer.location === "kot" || printer.location === "all") &&
      printer.isConnected
  );

  const orderData = {
    type,
    cartItems,
    roomData,
    extraCartItems,
    cancelItems,
    comment,
    billNo,
    customer,
    formattedDateTime,
    hightLightOrderIDLastNDigits,
  };

  if (kotPrinters && kotPrinters.length > 0) {
    kotPrinters.forEach((printer) => {
      printer.print(orderData, "kot");
    });
    return;
  }

  defaultPrinterPrint({
    type,
    cartItems,
    roomData,
    extraCartItems,
    cancelItems,
    comment,
    billNo,
    customer,
    formattedDateTime,
    hightLightOrderIDLastNDigits,
  });
};

const defaultPrinterPrint = ({
  type,
  cartItems,
  roomData,
  extraCartItems,
  cancelItems = [],
  comment,
  billNo,
  customer,
  formattedDateTime,
  hightLightOrderIDLastNDigits = 0,
}) => {
  let customerDetailsTemplate = "";
  if (type === "Parcel KOT") {
    customerDetailsTemplate = `
        ${customer.name != "NA" && customer.name != ""
        ? '<hr style="border: 0; border-top: 1px solid #000; margin: 0.5rem 0;" />'
        : ""
      }
        <div class="customer-info" style="font-size: 0.8rem;">
        ${customer.name != "NA" && customer.name != ""
        ? `<div><span id="customer-name"><strong>Customer:</strong> ${customer.name} </span></div>`
        : ""
      }
        ${customer.phone != 0 && customer.phone != "NA"
        ? `<div><span class="info-label">Ph:</span> <span id="customer-phone">${customer.phone}</span></div>`
        : ""
      }
        ${customer.address != "NA" && customer.address != ""
        ? `<div><span class="info-label">Add:</span> <span id="customer-address">${customer.address}</span></div>`
        : ""
      }
        </div>
    `;
  } else {
    customerDetailsTemplate = `
    ${customer.name != "NA" && customer.name != ""
        ? '<hr style="border: 0; border-top: 1px solid #000; margin: 0.5rem 0;" />'
        : ""
      }
    <div class="customer-info" style="font-size: 0.8rem;">
    ${customer.name != "NA" && customer.name != ""
        ? `<div><span id="customer-name"><strong>Customer:</strong> ${customer.name} </span></div>`
        : ""
      }
    </div>
    `;
  }

  let normalBillNo = billNo.toString();
  if (hightLightOrderIDLastNDigits > 0) {
    normalBillNo = normalBillNo.slice(0, -hightLightOrderIDLastNDigits);
    normalBillNo += `- ${billNo
      .toString()
      .slice(-hightLightOrderIDLastNDigits)}`;
  }

  const KOT = `
      <html>
      <head>  
        <title>KOT - ${billNo}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
          @media print {
            body { margin: 0; padding: 0; }
            .kot-container { padding: 6px; }
          }
          
          body {
            margin: 0;
            font-size: 14px;
            padding: 0;
            font-family: Arial, sans-serif;
            background-color: white;
            line-height: 1.3;
          }
          
          .kot-container {
            width: calc(100% - 12px);
          }
          
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .text-left { text-align: left; }
          .text-bold { font-weight: bold; }
          
          .divider {
            margin: 10px 0;
            border-top: 1px dashed #000;
          }
          
          .mb-12 { margin-bottom: 12px; }
          .mb-8 { margin-bottom: 8px; }
          .mb-6 { margin-bottom: 6px; }
          .mt-12 { margin-top: 12px; }
          
          .font-sm { font-size: 12px; }
          .font-md { font-size: 13px; }
          .font-lg { font-size: 15px; }
          .font-xl { font-size: 16px; }
          
          table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .item-row td {
            padding: 4px 0;
            vertical-align: top;
          }
          
          .capitalize {
            text-transform: capitalize;
          }
          
          h2 {
            font-size: 18px;
            font-weight: bold;
            margin: 0 0 6px 0;
            line-height: 1.2;
            text-align: center;
          }
          
          p {
            margin: 0 0 6px 0;
            line-height: 1.2;
          }
          
          .header-info {
            font-size: 12px;
            line-height: 1.2;
            margin: 0 0 4px 0;
          }
          
          .kot-info-table td {
            font-size: 13px;
            padding: 2px 0;
          }
          
          .items-header th {
            font-size: 13px;
            padding: 4px 0;
            border-bottom: 1px solid #000;
            font-weight: bold;
          }
          
          .item-name {
            font-size: 13px;
            font-weight: bold;
          }
          
          .variant-name {
            font-size: 13px;
            color: black;
            font-weight: normal;
          }
          
  /* Strike-through entire row */
      .strike-row {
        position: relative;
      }

      .strike-row::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        border-top: 2px solid red;
        z-index: 1;
      }


          .item-name-container {
            text-align: left;
            flex: 0 1 auto;
            max-width: 80%;
          }

          .quantity-container {
            text-align: right;
            flex: 0 0 40px;
          }
          
          .footer-text {
            font-size: 11px;
            text-align: center;
            margin-top: 12px;
          }

          .customer-info {
            font-size: 13px;
            line-height: 1.4;
          }

          .customer-info div {
            margin-bottom: 4px;
          }
        </style>
      </head>  

      <div class="kot-container">
        <h2>${type}</h2>
        
        <div class="divider"></div>
        
        <table class="kot-info-table">
          <tr>
            <td><strong>${formattedDateTime}</strong></td>
          </tr>
          <tr>
            <td><strong>Table: <span class="font-xl">${roomData.table}</span></strong> - <span class="font-sm">Room: ${roomData.room
    }</span></td>
          </tr>
          <tr>
            <td><span class="font-sm">Bill No: ${billNo}</span></td>
          </tr>
        </table>
       
        ${customerDetailsTemplate}

        <div class="divider"></div>
        
        <table>
          <thead>
            <tr class="items-header">
              <th class="text-left">Item</th>
              <th class="text-right" style="width: 60px;">Qty.</th>
            </tr>
          </thead>
          <tbody>
            ${cancelItems
      ?.map(
        (item) =>
          `
                <tr class="item-row strike-row">
                <td>
                  <div class="item-name">${item.name}                   ${item.isVariant
            ? `<span class="variant-name">- ${item.variantName}</span>`
            : ""
          }</div>
                  ${(item.addOn || item.addOns || item.addons || []).length > 0
            ? `<div class="font-sm" style="margin-top: 2px;">
                          ${(item.addOn || item.addOns || item.addons || []).map(a => `<div style="margin-left: 8px;">* ${a.name}</div>`).join('')}
                         </div>`
            : ""
          }
                  ${item.comment
            ? `<div class="font-sm" style="margin-top: 2px;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-down-right">
                            <polyline points="15 10 20 15 15 20"/>
                            <path d="M4 4v7a4 4 0 0 0 4 4h12"/>
                          </svg>
                          ${item.comment}
                        </div>`
            : ""
          }
                </td>
                <td class="text-right">${item.quantity}</td>
              </tr>
            `
      )
      ?.join("")}
            ${cartItems
      .filter((item) => !item.canceled)
      .map(
        (item) => `
              <tr class="item-row">
                <td>
                  <div class="item-name">${item.name}                   ${item.isVariant
            ? `<span class="variant-name">- ${item.variantName}</span>`
            : ""
          }</div>
                  ${(item.addOn || item.addOns || item.addons || []).length > 0
            ? `<div class="font-sm" style="margin-top: 2px;">
                          ${(item.addOn || item.addOns || item.addons || []).map(a => `<div style="margin-left: 8px;">* ${a.name}</div>`).join('')}
                         </div>`
            : ""
          }
                  ${item.comment
            ? `<div class="font-sm" style="margin-top: 2px;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-down-right">
                            <polyline points="15 10 20 15 15 20"/>
                            <path d="M4 4v7a4 4 0 0 0 4 4h12"/>
                          </svg>
                          ${item.comment}
                        </div>`
            : ""
          }
                </td>
                <td class="text-right">${item.quantity}</td>
              </tr>
            `
      )
      .join("")}
          </tbody>
        </table>

        ${comment
      ? `
            <div class="divider"></div>
            <div class="font-md">
              <strong>Comment:</strong> ${comment}
            </div>
          `
      : ""
    }

        <div class="divider"></div>
        <p class="footer-text">Powered by QRapid</p>
      </div>
      </html>
    `;

  const WinPrint = window.open("", "", "width=800,height=600");
  WinPrint.document.write(KOT);
  WinPrint.document.close();
  WinPrint.focus();

  setTimeout(() => {
    WinPrint.print();
    WinPrint.close();
  }, 250);
};
// sdsd